import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param cnId
 * @param poId
 */
class CNServices {
    /**
     *
     * @param {*} payload
     * @return
     */
    createCN = async (payload) => {
      const cn = await Helpers.post({
        url: Constants.CN,
        data: payload,
      });
      return cn;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
     updateCN = async (payload) => {
       const cn = await Helpers.put({
         url: Constants.CN,
         data: payload,
       });
       return cn;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
     updateCNStatus = async (payload) => {
       const po = await Helpers.put({
         url: Constants.CN_STATUS,
         data: payload,
       });
       return po;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
        updateCNWorkflowStep = async (payload) => {
          const cn = await Helpers.post({
            url: Constants.CN_WORKFLOW,
            data: payload,
          });
          return cn;
        }

        /**
         *
         * @param {*} payload
         * @return
         */
      deleteCN = async (payload) => {
        const cn = await Helpers.delete({
          url: Constants.CN,
          data: payload,
        });
        return cn;
      }

      /**
       * @param {*} orgId
       * @param {*} entityType
       * @param {*} cnId
       * @param {*} page
       * @param tenantId
       * @param customerId
       * @param searchKeyword
       * @param {*} limit
       * @return
       */
    getCN = async (tenantId, cnId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, accountManagerIds, docType, is_list) => {
      let url = `${Constants.CN}?`;
      if (tenantId) url += `tenant_ids=${tenantId}&`;
      if (cnId) url += `cn_id=${cnId}&`;
      if (limit) url += `limit=${limit}&`;
      if (page) url += `page=${page}&`;
      if (customerId) url += `customer_id=${customerId}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      if (status) url += `status=${status}&`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (docType) url += `doc_type=${docType}&`;
      if (is_list) url += `is_list=true&`;
      const cn = await Helpers.get({ url });
      return cn;
    }

    linkPaymentToCn = async (payload) => {
      const url = `${Constants.CN}/linkpayment`;
      const linkPayment = await Helpers.post({
        url,
        data: payload,
      });
      return linkPayment;
    }
}
export default new CNServices();
